import { render, staticRenderFns } from "./KInput.vue?vue&type=template&id=3bcfe914&"
import script from "./KInput.vue?vue&type=script&lang=js&"
export * from "./KInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports